export const roamingConfigCode = `
export default {
    "paths": [
      {
        "id": "default",
        "group": [
          {
            "id": "roaming-default-M08Ny7mOz9WzPjLqfe0_I",
            "spotId": "p0",
            "animation": {
              "duration": 3,
              "direction": 1,
              "from": {
                "ath": 7,
                "atv": -9
              },
              "to": {
                "ath": 65,
                "atv": 3
              }
            },
            "transition": {
              "duration": 2
            },
            "audio": {
              "enable": false,
              "name": "",
              "url": "",
              "text": "",
              "voice": "aijia",
              "duration": 0
            }
          },
          {
            "id": "roaming-default-waRjdmF0F0ey_x2dALJJU",
            "spotId": "p1",
            "animation": {
              "duration": 3,
              "direction": 1,
              "from": {
                "ath": 65,
                "atv": 3
              },
              "to": {
                "ath": 65,
                "atv": 3
              }
            },
            "transition": {
              "duration": 2
            },
            "audio": {
              "enable": false,
              "name": "",
              "url": "",
              "text": "",
              "voice": "aijia",
              "duration": 0
            }
          },
          {
            "id": "roaming-default-5zp_TLrzxdhHqW3yFDfT-",
            "spotId": "p2",
            "animation": {
              "duration": 3,
              "direction": 1,
              "from": {
                "ath": 30,
                "atv": 3
              },
              "to": {
                "ath": 76,
                "atv": -7
              }
            },
            "transition": {
              "duration": 2
            },
            "audio": {
              "enable": false,
              "name": "",
              "url": "",
              "text": "",
              "voice": "aijia",
              "duration": 0
            }
          },
          {
            "id": "roaming-default-Np7ZLQDm-zYnB2xpCAWyR",
            "spotId": "p3",
            "animation": {
              "duration": 3,
              "direction": 1,
              "from": {
                "ath": 76,
                "atv": -7
              },
              "to": {
                "ath": 11,
                "atv": -7
              }
            },
            "transition": {
              "duration": 2
            },
            "audio": {
              "enable": false,
              "name": "",
              "url": "",
              "text": "",
              "voice": "aijia",
              "duration": 0
            }
          }
        ]
      }
    ]
  }`;
